<div class="p-4 md:p-6">
  <!-- Page Header -->
  <h1 class="text-2xl font-bold text-gray-800 flex items-center">
    <mat-icon style="color: #1C593D; margin-right: 8px;">account_balance_wallet</mat-icon>
    Balance CBPay
    <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
      {{ total }} registros
    </span>
  </h1>
  <span class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2">
    {{ total }} registros
  </span>

  <!-- Filter Card -->
  <div class="flex justify-center mt-6 mb-6">
    <div class="w-full max-w-4xl bg-white p-6 rounded-xl shadow-lg border border-gray-100">
      <div class="flex items-center gap-2 mb-4">
        <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">filter_list</mat-icon>
        <span class="text-sm font-semibold" style="color: #1e5a3f;">Filtros de búsqueda</span>
      </div>
      <!-- Date Fields -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Desde</mat-label>
          <input matInput [matDatepicker]="fromPicker" [(ngModel)]="from">
          <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Hasta</mat-label>
          <input matInput [matDatepicker]="toPicker" [(ngModel)]="to">
          <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center justify-center gap-3 mt-2">
        <button type="button" (click)="loadMovements()"
          style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
          Buscar
        </button>

        <button type="button" (click)="exportToExcel()"
          [disabled]="!movements || movements.length === 0"
          [style.opacity]="!movements || movements.length === 0 ? '0.5' : '1'"
          [style.cursor]="!movements || movements.length === 0 ? 'not-allowed' : 'pointer'"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; transition: all 0.2s ease;"
          onmouseover="if(!this.disabled)this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">download</mat-icon>
          Exportar XLS
        </button>

        <button type="button" (click)="reload()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">refresh</mat-icon>
          Refrescar
        </button>
      </div>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 12px; padding: 16px; margin-bottom: 16px; text-align: center;">
    <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #dc2626;">error_outline</mat-icon>
      <span style="font-weight: 600; color: #dc2626;">{{ errorMessage }}</span>
    </div>
  </div>

  <!-- Desktop Table -->
  <div class="hidden lg:block" *ngIf="dataSource.data.length > 0">
    <div style="background: white; border-radius: 16px; overflow: hidden; border: 1px solid #e5e7eb; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);">
      <div style="overflow-x: auto; max-height: 60vh;">
        <table mat-table [dataSource]="dataSource" class="w-full">

          <!-- Transaction ID -->
          <ng-container matColumnDef="transactionId">
            <th mat-header-cell *matHeaderCellDef>Transaction ID</th>
            <td mat-cell *matCellDef="let row">
              <span class="font-mono font-bold text-xs" style="color: #1e5a3f;">{{ row.transactionId }}</span>
            </td>
          </ng-container>

          <!-- Fecha -->
          <ng-container matColumnDef="transactionDate">
            <th mat-header-cell *matHeaderCellDef>Fecha</th>
            <td mat-cell *matCellDef="let row">
              <span class="text-xs" style="color: #374151;">{{ row.transactionDate | date:'dd/MM/yyyy HH:mm' }}</span>
            </td>
          </ng-container>

          <!-- Tipo -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td mat-cell *matCellDef="let row">
              <span class="px-2 py-0.5 text-xs font-semibold rounded-full bg-blue-100 text-blue-700">{{ row.type }}</span>
            </td>
          </ng-container>

          <!-- Débito USD -->
          <ng-container matColumnDef="debitUsd">
            <th mat-header-cell *matHeaderCellDef>Débito USD</th>
            <td mat-cell *matCellDef="let row">
              <span class="font-bold text-xs" [style.color]="row.debitUsd && +row.debitUsd !== 0 ? '#dc2626' : '#374151'">
                {{ formatNumber(row.debitUsd) }}
              </span>
            </td>
          </ng-container>

          <!-- Crédito USD -->
          <ng-container matColumnDef="creditUsd">
            <th mat-header-cell *matHeaderCellDef>Crédito USD</th>
            <td mat-cell *matCellDef="let row">
              <span class="font-bold text-xs" [style.color]="row.creditUsd && +row.creditUsd !== 0 ? '#16a34a' : '#374151'">
                {{ formatNumber(row.creditUsd) }}
              </span>
            </td>
          </ng-container>

          <!-- Balance USD -->
          <ng-container matColumnDef="balanceUsd">
            <th mat-header-cell *matHeaderCellDef>Balance USD</th>
            <td mat-cell *matCellDef="let row">
              <span class="font-bold text-xs" style="color: #1e5a3f;">{{ formatNumber(row.balanceUsd) }}</span>
            </td>
          </ng-container>

          <!-- Descripción -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Descripción</th>
            <td mat-cell *matCellDef="let row">
              <span class="text-xs" style="color: #374151;">{{ row.description }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </div>

  <!-- Mobile Cards -->
  <div class="lg:hidden" *ngIf="dataSource.data.length > 0">
    <div class="flex flex-col gap-3">
      <div *ngFor="let row of dataSource.data; let i = index"
        style="background: white; border-radius: 12px; overflow: hidden; transition: all 0.2s ease;"
        [style.border]="expandedCardId === i ? '1.5px solid #1C593D' : '1px solid #e5e7eb'"
        [style.box-shadow]="expandedCardId === i ? '0 4px 12px rgba(28,89,61,0.15)' : '0 1px 3px rgba(0,0,0,0.1)'">

        <!-- Card Header -->
        <div (click)="toggleCard(i)"
          style="display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; cursor: pointer;"
          [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
          <div style="display: flex; align-items: center; gap: 8px; flex: 1; min-width: 0; flex-wrap: wrap;">
            <span class="font-mono font-bold text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800">
              {{ row.transactionId }}
            </span>
            <span class="px-2 py-0.5 text-xs font-semibold rounded-full bg-blue-100 text-blue-700">
              {{ row.type }}
            </span>
            <span class="font-bold text-xs" style="color: #1e5a3f; margin-left: auto;">
              {{ formatNumber(row.balanceUsd) }} USD
            </span>
          </div>
          <mat-icon style="color: #6b7280; transition: transform 0.2s ease; margin-left: 8px;"
            [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>

        <!-- Card Body -->
        <div *ngIf="expandedCardId === i" style="padding: 0 16px 16px 16px;">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
            <div>
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Fecha</span>
              <span style="font-size: 0.85rem; color: #374151; font-weight: 500;">{{ row.transactionDate | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <div>
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Tipo</span>
              <span class="px-2 py-0.5 text-xs font-semibold rounded-full bg-blue-100 text-blue-700">{{ row.type }}</span>
            </div>
            <div>
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Débito USD</span>
              <span style="font-weight: 700; font-size: 0.9rem;" [style.color]="row.debitUsd && +row.debitUsd !== 0 ? '#dc2626' : '#374151'">
                {{ formatNumber(row.debitUsd) }}
              </span>
            </div>
            <div>
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Crédito USD</span>
              <span style="font-weight: 700; font-size: 0.9rem;" [style.color]="row.creditUsd && +row.creditUsd !== 0 ? '#16a34a' : '#374151'">
                {{ formatNumber(row.creditUsd) }}
              </span>
            </div>
            <div style="grid-column: span 2;">
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Balance USD</span>
              <span style="font-weight: 800; font-size: 1rem; color: #1e5a3f;">{{ formatNumber(row.balanceUsd) }}</span>
            </div>
            <div *ngIf="row.description" style="grid-column: span 2;">
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Descripción</span>
              <span style="font-size: 0.85rem; color: #374151;">{{ row.description }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!dataSource.data.length && !errorMessage"
    style="text-align: center; padding: 40px 20px; background: white; border-radius: 16px; border: 1px solid #e5e7eb; margin-top: 16px;">
    <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db;">search_off</mat-icon>
    <p style="color: #6b7280; font-weight: 500; margin-top: 12px;">No se encontraron registros para los filtros seleccionados.</p>
  </div>

  <!-- Paginator -->
  <mat-paginator #paginator
    [length]="total"
    [pageSize]="limit"
    [showFirstLastButtons]="true"
    [pageSizeOptions]="[5, 10, 25, 50, 100]"
    [pageIndex]="page - 1"
    aria-label="Select page"
    (page)="onPageChange($event)"
    style="margin-top: 16px; border-radius: 12px; overflow: hidden;">
  </mat-paginator>
</div>
